/// Compartilhado pelo painel do lead (Meta) e pelo multicanal (Chatwoot).
export enum MessageStatus {
    Pending = 0,
    Sent = 1,
    Delivered = 2,
    Read = 3,
    Failed = 4,
}
